module.exports = __webpack_public_path__ + "img/banner.337a61f6.jpg";